import './style.css'

const LoadingBar = () => {
    return (
        <span className="loaderbar"></span>
    )
}


export default LoadingBar;
